<template>
  <v-card
      v-if="content && Volunteer"
  >
    <v-card-title>
      <span
          class="text-truncate"
          style="max-width: 900px"
      >
        {{ Volunteer.name }}
      </span>

      <v-spacer/>

      <v-btn
          :icon="true"
          :outlined="true"
          color="primary"
          to="/volunteers"
      >
        <v-icon>
          mdi-reply
        </v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col
            cols="12"
        >
          <Applications
              :Volunteer="Volunteer"
          />
        </v-col>

        <v-col
            cols="12"
        >
          <Documents
              :Volunteer="Volunteer"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>

  <v-progress-circular
      v-else
      :indeterminate="true"
  />
</template>

<script>
  import Volunteers from '@/services/volunteers'

  import Applications from '@/components/Volunteer/Applications'
  import Documents from '@/components/Volunteer/Documents'

  export default {
    name: 'Volunteer',
    components: {
      Applications,
      Documents
    },
    data() {
      return {
        content: false,
        loading: false,
        Volunteer: null
      }
    },
    metaInfo() {
      return {
        title: (
          this.Volunteer
            ? this.Volunteer.name
            : ''
        )
      }
    },
    mounted() {
      this.init()
    },
    watch: {
      $route(to, from) {
        if (to.path !== from.path) {
          this.init()
        }
      }
    },
    methods: {
      init() {
        this.loadData()
      },
      refresh() {
        this.loadData('loading', true)
      },
      setBreadcrumbs() {
        this.$store.dispatch('layout/setBreadcrumbs', {
          breadcrumbs: [
            {
              text: 'Dobrovoľníci',
              to: '/volunteers'
            }
          ]
        })
      },
      loadData(key = 'content', value = false) {
        this[key] = value

        Volunteers
          .read({
            id: this.$route.params.id
          })
          .then((response) => {
            this.setBreadcrumbs()

            this.$store.dispatch('layout/addBreadcrumbs', {
              breadcrumbs: [
                {
                  text: response.data.data.Volunteer.name,
                  to: '/volunteer/' + response.data.data.Volunteer.id
                }
              ]
            })

            this.Volunteer = response.data.data.Volunteer
          })
          .catch((error) => {
            switch (error.response.status) {
              case 401:
              case 404:
              case 500:
                this.$store.dispatch('layout/openSnackbar', {
                  message: error.response.data.message
                })

                this.$router.replace('/volunteers')

                break
            }
          })
          .finally(() => {
            this[key] = !value
          })
      }
    }
  }
</script>
